import {Search2Icon} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Checkbox,
  Grid,
  HStack,
  Input, Select,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react'
import React, {useState} from "react";
import {useQuery} from "react-query";
import {useParams} from "react-router-dom";

import Admin from "../../admin/components/Admin";
import {getLicenses} from "../Api";
import {useAuthentication} from "../hooks/AuthenticationProvider";
import {disableBlurProtection} from "../hooks/BlurProtection";
import {Authority} from "../model/Constants";
import {adminKeys} from "../QueryKeys";
import {
  enableKeyCommands,
  extractData,
  toIsoString
} from "../Utils";
import DownloadLicensesResults from './DownloadLicensesResults';
import LicenseItem from "./LicenseItem";

const LicensesList = (props: {isPublic?:boolean; uniband?:boolean} ) => {
  const params = useParams<{
    institution: string;
  }>();

  disableBlurProtection();
  enableKeyCommands();

  const authentication = useAuthentication();
  const isAdmin =
    authentication?.currentUserQuery?.data?.data?.authorities?.includes(Authority.ROLE_ADMIN);
  const noInstitution = !authentication.currentUserQuery?.data?.data?.institution;
  const [institutionValue, setInstitutionValue] = useState<string>(
    props.isPublic ? params?.institution?.trim().toLowerCase() || "" :
      authentication.currentUserQuery?.data?.data?.institution?.trim().toLowerCase() || "");

  const today: string = toIsoString(new Date()).slice(0, 10);

  const minDate: string = institutionValue==="aliarse"?"2024-06-01": "2022-12-01";
  const [startDateValue, setStartDateValue] = useState<string>(today);
  const [endDateValue, setEndDateValue] = useState<string>(today);

  const [regionValue, setRegionValue] = useState<string>("");
  const [licenseValue, setLicenseValue] = useState<string>("");
  const [idValue, setIdValue] = useState<string>("");
  const [nameValue, setNameValue] = useState<string>("");
  const [level, setLevel] = useState<string>("All");

  // public should only get used licenses
  const [includeAvailable, setIncludeAvailable] = useState<boolean>(
    false
  );
  const [includeUnavailable, setIncludeUnavailable] = useState<boolean>(
    true
  );
  const [includeInvited, setIncludeInvited] = useState<boolean>(false);
  const [includeInProgress, setIncludeInProgress] = useState<boolean>(true);
  const [includeCompleted, setIncludeCompleted] = useState<boolean>(true);
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(25);

  const licensesQuery = useQuery(adminKeys.candidatesSummary(), () =>
      getLicenses({
        licenseValue: licenseValue.trim().toLowerCase(),
        usernameValue: idValue.trim().toLowerCase(),
        nameValue: nameValue.trim().toLowerCase(),
        startDateValue: startDateValue,
        endDateValue: endDateValue,
        institution: institutionValue.trim().toLowerCase(),
        region: regionValue.trim().toLowerCase(),
        includeInvited: includeInvited,
        includeInProgress: includeInProgress,
        includeCompleted: includeCompleted,
        includeAvailable: includeAvailable,
        includeUnavailable: includeUnavailable,
        isPublic: props.isPublic,
        level: level
      } ).then(extractData),
    {retry: true, refetchOnWindowFocus: false, enabled: false}
  );

  function calculateCols() {
    const base = 4; /*
                  <Text fontWeight="bold">Prueba</Text>
                  <Text fontWeight="bold">Estado</Text>
                  <Text fontWeight="bold">Inicio-Fin</Text>
                  { !props.isPublic && <Text fontWeight="bold">Banda</Text> }
                  <Text fontWeight="bold">Última pregunta</Text>
                  { !props.isPublic && props.userInstitution==="tweetalig" && <Text fontWeight="bold">Puntaje</Text>}
                                        */
    const notPublic = !props.isPublic ? 1 : 0;
    const notPublicAndTw = !props.isPublic && institutionValue==="tweetalig" ? 1 : 0;
    return base + notPublic + notPublicAndTw;
  }
  function handleKeyPress (key: string) {
    if (key === 'Enter') {
      return licensesQuery.refetch();
    }
  }

    return (
      <Box width="95%" marginX="auto">
        <div>
          <HStack alignSelf="start" spacing={10}>
            { !props.isPublic && <DownloadLicensesResults endDateValue={endDateValue} startDateValue={startDateValue}
                                                          institution={institutionValue.trim().toLowerCase()}
                                                          includeInvited={includeInvited} includeInProgress={includeInProgress}
                                                          includeCompleted={includeCompleted} includeAvailable={includeAvailable}
                                                          includeUnavailable={includeUnavailable}
                                                          region={regionValue.trim().toLowerCase()}
                                                          nameValue={nameValue.trim().toLowerCase()}
                                                          licenseValue={licenseValue.trim().toLowerCase()}
                                                          usernameValue={idValue.trim().toLowerCase()}
                                                          level={level}
            />}
            { (noInstitution && !props.isPublic) &&
              <Input placeholder='Institución'
                     onKeyDown={(event) => handleKeyPress(event.key)}
                     onChange={(event)=>
                       setInstitutionValue(event.target.value.trim().toLowerCase())}/>
            }
            { (!props.isPublic) &&
              <Input placeholder='Región'
                     onKeyDown={(event) => handleKeyPress(event.key)}
                     onChange={(event)=>
                       setRegionValue(event.target.value.trim().toLowerCase())}/>
            }
          </HStack >
          <HStack alignSelf="start" spacing={10} paddingY={2}>
            <Input type="date" id="startDate" value={startDateValue}
                   min={minDate}
                   onChange={(event) => {
                     setStartDateValue(event.target.value);
                   }}/>
            <Input type="date" id="endDate" value={endDateValue}
                   min={minDate}
                   onChange={ (event) => {
                     setEndDateValue(event.target.value);
                   }}/>
            <Checkbox minW="fit-content"
                      onChange={ (e) => {
                        setIncludeInvited(e.target.checked);
                      }}
                      defaultChecked={includeInvited}>
              Sin iniciar
            </Checkbox>
            <Checkbox minW="fit-content"
                      onChange={ (e) => {
                        setIncludeInProgress(e.target.checked);
                      }}
                      defaultChecked={includeInProgress}>
              En proceso
            </Checkbox>
            <Checkbox minW="fit-content"
                      onChange={ (e) => {
                        setIncludeCompleted(e.target.checked);
                      }}
                      defaultChecked={includeCompleted}>
              Completados
            </Checkbox>
          </HStack >
          <HStack alignSelf="start" spacing={10} paddingY={2}>
            <Input placeholder='Licencia'
                   onKeyDown={(event) => handleKeyPress(event.key)}
                   onChange={(event)=>setLicenseValue(event.target.value)}/>
            <Input placeholder='Identificación'
                   onKeyDown={(event) => handleKeyPress(event.key)}
                   onChange={(event)=>setIdValue(event.target.value)}/>
            <Input placeholder='Nombre'
                   onKeyDown={(event) => handleKeyPress(event.key)}
                   onChange={(event)=>setNameValue(event.target.value)} />
          </HStack >
          <HStack alignSelf="start" spacing={10} paddingY={2}>
            <Select value={pageSize.toString()} isReadOnly={true} width="1xs"
                    onChange={(event)=> {setPageSize(parseInt(event.target.value)); }}>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Select>

            <Button leftIcon={<Search2Icon />} colorScheme="teal" onClick={()=> {
              setPage(0);
              return licensesQuery.refetch();
            }}
                    disabled={licensesQuery.isFetching}>
              Buscar
            </Button>

            { !props.isPublic && <Checkbox minW="fit-content"
                                           onChange={ (e) => {
                                             setIncludeAvailable(e.target.checked);
                                           }}
                                           defaultChecked={includeAvailable}>
              Desocupadas
            </Checkbox>}
            { !props.isPublic && <Checkbox minW="fit-content"
                                           onChange={ (e) => {
                                             setIncludeUnavailable(e.target.checked);
                                           }}
                                           defaultChecked={includeUnavailable}>
              Ocupadas
            </Checkbox>
            }
            { props.uniband===true &&
              <Select value={pageSize.toString()} isReadOnly={true} width="1xs"
                    onChange={(event)=> {setLevel(event.target.value); }}>
                <option value={"All"}>Todas</option>
                <option value={"A1"}>A1</option>
                <option value={"A2"}>A2</option>
                <option value={"B1"}>B1</option>
                <option value={"B2"}>B2</option>
                <option value={"C1"}>C1</option>
              </Select>
            }

            {licensesQuery.isFetching &&
              <Spinner />
            }
          </HStack >
        </div>

        <TableContainer width="95vw">
          <Table size='sm' variant='striped' whiteSpace="normal">
            <Thead>
              <Tr>
                <Th>Licencia</Th>
                <Th>ID</Th>
                <Th>Nombre</Th>
                <Th>Institución (Región)</Th>
                <Th>Grupo</Th>
                { !props.isPublic && <Th></Th> /*<Th>Overall</Th>*/ }
                { !props.isPublic && <Th>Constancia</Th>  /* <Th>Constancia</Th> */}

                <Th><Box key={"Box header"}
                    p={3}
                    bg="gray.50"
                    borderRadius="md"
                    border="1px solid"
                    borderColor="gray.100"
                  >
                    <Grid templateColumns={`repeat(${calculateCols()}, 1fr)`} placeItems="center" columnGap={2}>
                      <Text fontWeight="bold">Prueba</Text>
                      <Text fontWeight="bold">Estado</Text>
                      <Text fontWeight="bold">Inicio-Fin</Text>
                      { !props.isPublic && <Text fontWeight="bold">Banda</Text> }
                      <Text fontWeight="bold">Última pregunta</Text>
                      { !props.isPublic && institutionValue==="tweetalig" && <Text fontWeight="bold">Puntaje</Text>}
                    </Grid>
                  </Box>
                </Th>
              </Tr>
            </Thead>

            <Tbody key="List">
              {licensesQuery.isSuccess && licensesQuery.data.length ? (
                (licensesQuery.data).slice(page, page+pageSize).map((license) => (
                  <LicenseItem license={license}
                               userInstitution={institutionValue}
                               isAdmin={isAdmin}
                               isPublic={props.isPublic}
                                level={level}
                               uniband={props.uniband===true} />
                ))
              ) : (
                <Tr key={"empty"}>
                </Tr>
              )}

            </Tbody>
          </Table>
        </TableContainer>
        <HStack paddingY={10} justifyContent="end">
          <Button
            colorScheme="teal"
            disabled={page === 0}
            onClick={()=>setPage(page-pageSize)}
          >
            Anterior
          </Button>
          <Button
            colorScheme="teal"
            disabled={!licensesQuery.data || page+pageSize >= (licensesQuery.data).length}
            onClick={()=>setPage(page+pageSize)}
          >
            Siguiente
          </Button>
        </HStack>
      </Box>
    );
};

export default LicensesList;
